import styled, { css } from 'styled-components';

export const VisibilityController = styled.div<{ isVisible?: boolean }>`
  ${({ isVisible }) => css`
    visibility: ${!isVisible && 'hidden'};
  `}
`;
